export enum PriceTypesEnum {
  Monthly = 'Monthly',
  Annual = 'Annual',
}
